//
import React from 'react';
import { injectIntl } from 'react-intl';

import Notification from '../../components/common/notification/Notification';
import LoadingSpinner from '../common/spinner/LoadingSpinner';

import MsgAPI from '../../api/msg/MsgAPI';

import FrontendException from '../../models/FrontendException';

class ListDeletedMsg extends React.Component {
  constructor() {
    super();
    //
    this.mounted = false;
    this.notificationRef = React.createRef();
    this.defaultListValues = { 'optout_title': '' };
    //
    this.state = {
      loading: false,
      showMainContent: false
    };

  }

  componentDidMount() {
    this.mounted = true;
    //
    this.startLoader();
    //
    this.getDefaultListValues().then(() => {
      if (this.mounted) {
        this.setState({
          showMainContent: true
        });
      }
    }).catch((error) => {
      this.handleError(error, "default", true);
    })
      .finally(this.stopLoader);


  }



  componentWillUnmount() {
    this.mounted = false;
  }

  handleError = (error, source = "default", fatal = false) => {
    let errorLabel = "Load.Common.Error";
    if (error instanceof FrontendException) {
      errorLabel = error.label;
    } else if (this.isString(error)) {
      errorLabel = error;
    }
    //
    this.notificationRef.current.addError(this.props.intl.formatMessage({ id: errorLabel, defaultMessage: errorLabel }), source, false, !fatal);
  }

  getDefaultListValues() {
    return MsgAPI.getDefaultListValues().then((defaultListValues) => {
      this.defaultListValues = defaultListValues;
    });
  }

  isString(param) {
    return (typeof param === "string") || (param instanceof String);
  }

  startLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: true
      });
    }
  }

  stopLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    return (
      <div>
        <Notification ref={this.notificationRef} />
        {this.state.loading && <LoadingSpinner />}

        {this.state.showMainContent &&
          <div className="frontend-wrapper">
            <div className="frontend-box frontend-row">
              {this.defaultListValues.optout_title}
            </div>
          </div>
        }

      </div>
    );
  }

}


export default injectIntl(ListDeletedMsg);